import React from 'react';
import { isInMobileApp, handleNewTabLink } from '../../../services/Utils';

const Image = (props) => {

    if (!props.image_thumb) return '';

    return (
        <div className="image">

            <img src={props.image_thumb} alt={props.title} />

        </div>
    )
}

const EmphasisGroupCard = (props) => {

    const handleClick = (e) => {
        handleNewTabLink(e, props.target, props.url);
    }

    return (
        <article className="card group" onClick={handleClick}>

            <a href={props.url} target={props.target}>

                <div className="content">

                    <div className="center-wrap">

                        <Image {...props} />

                        <h6 className="title" dangerouslySetInnerHTML={{ __html: props.title }}></h6>

                        <div className="when" dangerouslySetInnerHTML={{ __html: props.when }}></div>

                        <div className="time" dangerouslySetInnerHTML={{ __html: props.time }}></div>

                        <div className="area" dangerouslySetInnerHTML={{ __html: props.area }}></div>

                    </div>

                </div>

            </a>

        </article>
    );

}

export default EmphasisGroupCard;
